module.exports = __webpack_public_path__ + "static/img/section6_content1_Bg2.96193125.png";